<template>
    <div class="player">
        <div class="player-controls">
            <button @click.prevent="stop" title="Stop">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <path
                        fill="currentColor"
                        d="M16,4.995v9.808C16,15.464,15.464,16,14.804,16H4.997C4.446,16,4,15.554,4,15.003V5.196C4,4.536,4.536,4,5.196,4h9.808C15.554,4,16,4.446,16,4.995z"
                    />
                </svg>
            </button>
            <button @click.prevent="playing = !playing" :title="playing ? 'Pause' : 'Play'">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <path
                        v-if="!playing"
                        fill="currentColor"
                        d="M15,10.001c0,0.299-0.305,0.514-0.305,0.514l-8.561,5.303C5.51,16.227,5,15.924,5,15.149V4.852c0-0.777,0.51-1.078,1.135-0.67l8.561,5.305C14.695,9.487,15,9.702,15,10.001z"
                    />
                    <path
                        v-else
                        fill="currentColor"
                        d="M15,3h-2c-0.553,0-1,0.048-1,0.6v12.8c0,0.552,0.447,0.6,1,0.6h2c0.553,0,1-0.048,1-0.6V3.6C16,3.048,15.553,3,15,3z M7,3H5C4.447,3,4,3.048,4,3.6v12.8C4,16.952,4.447,17,5,17h2c0.553,0,1-0.048,1-0.6V3.6C8,3.048,7.553,3,7,3z"
                    />
                </svg>
            </button>
            <button :style="{fontSize: '15px'}" class="player-minus-seconds" title="Minus 5 seconds" @click="decreaseSeconds(5)">
                -5
            </button>
            <button :style="{fontSize: '15px'}" class="player-plus-seconds" title="Plus 5 seconds" @click="increaseSeconds(5)">
                +5
            </button>
<!--            <button @click.prevent="speedDown" title="Speed down">-->
<!--                <svg viewBox="0 0 24 24" style="height: 20px; width: 20px;">-->
<!--                    <path-->
<!--                        d="M12 16C13.66 16 15 14.66 15 13C15 11.88 14.39 10.9 13.5 10.39L3.79 4.77L9.32 14.35C9.82 15.33 10.83 16 12 16M12 3C10.19 3 8.5 3.5 7.03 4.32L9.13 5.53C10 5.19 11 5 12 5C16.42 5 20 8.58 20 13C20 15.21 19.11 17.21 17.66 18.65H17.65C17.26 19.04 17.26 19.67 17.65 20.06C18.04 20.45 18.68 20.45 19.07 20.07C20.88 18.26 22 15.76 22 13C22 7.5 17.5 3 12 3M2 13C2 15.76 3.12 18.26 4.93 20.07C5.32 20.45 5.95 20.45 6.34 20.06C6.73 19.67 6.73 19.04 6.34 18.65C4.89 17.2 4 15.21 4 13C4 12 4.19 11 4.54 10.1L3.33 8C2.5 9.5 2 11.18 2 13Z"-->
<!--                        style="fill: currentcolor;"-->
<!--                    />-->
<!--                </svg>-->
<!--            </button>-->
<!--            <button @click.prevent="speedUp" title="Speed up">-->
<!--                <svg viewBox="0 0 24 24" style="height: 20px; width: 20px;">-->
<!--                    <path-->
<!--                        d="M12,16A3,3 0 0,1 9,13C9,11.88 9.61,10.9 10.5,10.39L20.21,4.77L14.68,14.35C14.18,15.33 13.17,16 12,16M12,3C13.81,3 15.5,3.5 16.97,4.32L14.87,5.53C14,5.19 13,5 12,5A8,8 0 0,0 4,13C4,15.21 4.89,17.21 6.34,18.65H6.35C6.74,19.04 6.74,19.67 6.35,20.06C5.96,20.45 5.32,20.45 4.93,20.07V20.07C3.12,18.26 2,15.76 2,13A10,10 0 0,1 12,3M22,13C22,15.76 20.88,18.26 19.07,20.07V20.07C18.68,20.45 18.05,20.45 17.66,20.06C17.27,19.67 17.27,19.04 17.66,18.65V18.65C19.11,17.2 20,15.21 20,13C20,12 19.81,11 19.46,10.1L20.67,8C21.5,9.5 22,11.18 22,13Z"-->
<!--                        style="fill: currentcolor;"-->
<!--                    />-->
<!--                </svg>-->
<!--            </button>-->
            <!--            <div class="player-time">-->
            <!--                {{ this.currentSecondsConverted }}-->
            <!--            </div>-->
            <!--            <div>-->
            <!--                <div class="player-timeline">-->
            <!--                    <div :style="progressStyle" class="player-progress" />-->
            <!--                    <div @click="seek" class="player-seeker" title="Seek" />-->
            <!--                </div>-->
            <!--            </div>-->
            <!--            <div class="player-time">-->
            <!--                {{ this.durationSecondsConverted }}-->
            <!--            </div>-->
        </div>
        <audio
            ref="audio"
            :src="file"
            @timeupdate="timeupdate"
            @loadeddata="load"
            @pause="playing = false"
            @play="playing = true"
            preload="auto"
        />
    </div>
</template>
<script>
    export default {
        props: {
            autoPlay: {
                type: Boolean,
                default: true,
            },
            file: {
                type: String,
                required: true,
            },
            playbackSpeed: {
                type: Number,
                default: 1,
            }
        },
        data: () => ({
            currentSeconds: 0,
            durationSeconds: 0,
            loaded: false,
            playing: false,
            speed: 1,
        }),
        watch: {
            playing(value) {
                if (value) {
                    return this.$refs.audio.play();
                }
                this.$refs.audio.pause();
            },
        },
        mounted() {
            if (this.$refs.audio) {
                this.$refs.audio.playbackRate = this.playbackSpeed;
            }
        },
        methods: {
            load() {
                if (this.$refs.audio.readyState >= 2) {
                    this.loaded = true;
                    this.durationSeconds = parseInt(this.$refs.audio.duration);
                    return (this.playing = this.autoPlay);
                }
                throw new Error('Failed to load sound file.');
            },
            stop() {
                this.playing = false;
                this.$refs.audio.currentTime = 0;
            },
            timeupdate() {
                if (this.$refs.audio) {
                    this.currentSeconds = parseInt(this.$refs.audio.currentTime);
                }
            },
            increaseSeconds(seconds) {
                const time = this.$refs.audio.currentTime;
                this.$refs.audio.currentTime =
                    time + seconds > this.durationSeconds ? this.durationSeconds : time + seconds;
            },
            decreaseSeconds(seconds) {
                const time = this.$refs.audio.currentTime;
                this.$refs.audio.currentTime = time - seconds < 0 ? 0 : time - seconds;
            },
        },
    };
</script>
<style lang="scss" scoped>
    .player {
        display: flex;
        justify-content: center;
        margin-bottom: 20px;
        audio {
            display: none;
        }
        .player-controls {
            display: flex;
            gap: 10px;
            button {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 40px;
                height: 40px;
                border-radius: 5px;
                border-right: 1px solid #000;
                background-color: white;
                box-shadow: 1px 1px 3px #000;
                color: #404040;
                cursor: pointer;
                display: flex;
                line-height: 0;
                margin: 0;
                padding: 0.5em;
                text-decoration: none;
                > svg {
                    width: 18px;
                }
                transition-property: all;
                transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
                transition-duration: 150ms;
                &:hover {
                    color: #2266ff;
                    border-color: #2266ff;
                }
            }
            .player-plus-seconds,
            .player-minus-seconds {
                display: flex;
                align-items: center;
                padding: 0 10px;
                cursor: pointer;
                transition-property: all;
                transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
                transition-duration: 150ms;
                &:hover {
                    color: #2266ff;
                }
            }
            .player-time {
                display: flex;
                align-items: center;
                padding: 0 10px;
            }
            .player-timeline {
                background-color: #e0e0e0;
                width: 130px;
                position: relative;
                height: 100%;
                .player-progress,
                .player-seeker {
                    bottom: 0;
                    height: 100%;
                    left: 0;
                    position: absolute;
                    top: 0;
                }
                .player-progress {
                    background-color: #000000a3;
                    z-index: 1;
                }
                .player-seeker {
                    cursor: pointer;
                    width: 100%;
                    z-index: 2;
                }
            }
        }
    }
</style>
